import { graphql } from "@/graphql/codegen"
import "./salesOrderFragments"

graphql(`
  mutation UpdateSalesOrder($input: SalesOrderUpdateInput!) {
    salesOrder {
      update(input: $input) {
        __typename
        ... on SalesOrderUpdateSuccess {
          salesOrder {
            ...CustomerOrderSalesOrderFields
          }
        }
        ... on SalesOrderUpdateFailure {
          error {
            message
            missingFields
          }
        }
      }
    }
  }
`)
